// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_m_N","field":"styles_field__b9w6K","fieldCol":"styles_fieldCol__BCmdK","diffCol":"styles_diffCol__1ckBO","diff":"styles_diff__1oGlZ"};